import React, { useState } from 'react';
import { useLocations } from '@/hooks/useLocations';
import { useUser } from '@/context/UserContext';
import '../styles/Panels.css';

interface LocationsPanelProps {
    player: any;
    onClose?: () => void;
}

export const LocationsPanel: React.FC<LocationsPanelProps> = ({ player, onClose }) => {
    const { user } = useUser();
    const { locations, loading, addLocation, deleteLocation } = useLocations(user?.uid);
    const [newLocationName, setNewLocationName] = useState('');
    const [isAdding, setIsAdding] = useState(false);

    const handleSave = async () => {
        if (!newLocationName.trim() || !player) return;

        // Get current position from player
        const { x, y, z } = player.position;
        await addLocation(newLocationName, { x, y, z });
        setNewLocationName('');
        setIsAdding(false);
    };

    const handleTeleport = (loc: { x: number, y: number, z: number }) => {
        if (player && typeof player.teleportToIsland === 'function') {
            // Adjust Y by -2 because teleportToIsland adds +2 to the Y coordinate
            player.teleportToIsland({ x: loc.x, y: loc.y - 2, z: loc.z });
        }
    };

    return (
        <div className="panel">
            <div className="panel-header">
                <h2>Saved Locations 📍</h2>
                <button className="close-button" onClick={onClose}>×</button>
            </div>
            <div className="panel-content">
                {!isAdding ? (
                    <button className="task-button" onClick={() => setIsAdding(true)} style={{ width: '100%', textAlign: 'center', background: 'var(--primary-color)', color: 'black' }}>
                        + Save Current Location
                    </button>
                ) : (
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <input
                            type="text"
                            value={newLocationName}
                            onChange={(e) => setNewLocationName(e.target.value)}
                            placeholder="Location Name"
                            className="referral-input"
                            style={{ background: 'rgba(0,0,0,0.3)', padding: '8px', borderRadius: '4px' }}
                        />
                        <button onClick={handleSave} className="copy-button">Save</button>
                        <button onClick={() => setIsAdding(false)} className="copy-button" style={{ background: 'var(--danger-color)', color: 'white' }}>Cancel</button>
                    </div>
                )}

                {loading ? <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div> : (
                    <div className="task-list">
                        {locations.length === 0 ? (
                            <p style={{ textAlign: 'center', opacity: 0.7, fontStyle: 'italic' }}>No saved locations yet.</p>
                        ) : (
                            locations.map(loc => (
                                <div key={loc.id} className="task-item">
                                    <div className="task-info">
                                        <h3>{loc.name}</h3>
                                        <p>{loc.x.toFixed(0)}, {loc.y.toFixed(0)}, {loc.z.toFixed(0)}</p>
                                    </div>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <button onClick={() => handleTeleport(loc)} className="task-button">
                                            Teleport
                                        </button>
                                        <button
                                            onClick={() => deleteLocation(loc.id)}
                                            className="delete-btn"
                                            title="Delete Location"
                                        >
                                            🗑️
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
